import { MenuDownIcon } from './MenuDownIcon';

/**
 * author: Google
 * id 624A47B1-947E-45AD-A34F-D5DCC1143C5A
 * name menu-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-down.svg
 * tags
 * - Arrow 
 */
export const CaretDownIcon = MenuDownIcon;
export default CaretDownIcon